var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useMemo } from 'react';
import sortBy from 'lodash/sortBy';
import ThemedSelect from '../misc/ThemedSelect';
import './GraphSearch.scss';
function GraphSearchNoOptionsMessage(_a) {
    var inputValue = _a.inputValue;
    if (!inputValue)
        return React.createElement("span", null, "Try typing...");
    return React.createElement("span", null, "No results.");
}
export default function GraphSearch(_a) {
    var graph = _a.graph, renderer = _a.renderer, targetAttribute = _a.targetAttribute;
    var _b = useState(null), selectedOption = _b[0], setSelectedOption = _b[1];
    var options = useMemo(function () {
        var o = [];
        graph.forEachNode(function (node, attr) {
            var label = attr[targetAttribute.name];
            if (label) {
                o.push({ value: node, label: label });
            }
        });
        return sortBy(o, 'label');
    }, [graph, targetAttribute]);
    var onChange = function (option) {
        if (option === selectedOption)
            return;
        // NOTE: not ideal, but should do the trick before we upgrade sigma
        if (selectedOption)
            renderer.highlightedNodes.delete(selectedOption.value);
        if (option)
            renderer.highlightedNodes.add(option.value);
        renderer.scheduleHighlightedNodesRender();
        setSelectedOption(option);
    };
    return (React.createElement("div", { id: "GraphSearch" },
        React.createElement(ThemedSelect, { options: options, value: selectedOption, onChange: onChange, placeholder: "Search a node...", noOptionsMessage: GraphSearchNoOptionsMessage, isClearable: true, isSearchable: true, theme: function (theme) {
                return __assign(__assign({}, theme), { spacing: __assign(__assign({}, theme.spacing), { controlHeight: 42 }) });
            } })));
}
